export default "/images/info-background.svg?615c5cfe3b9d1cb95b8a56176015ecba";